import React from 'react';
import { Link } from 'react-router-dom';

export default function FestifyLogo({ size = 'large', subtitle }) {
  const isLarge = size === 'large';

  return (
    <Link to="/" className={isLarge ? 'festify-logo large' : 'festify-logo'}>
      <svg viewBox="0 0 180 84" aria-hidden="true" className="festify-logo-mark">
        <defs>
          <linearGradient id="festifyCircle" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#7ec3ff" />
            <stop offset="100%" stopColor="#2c8fff" />
          </linearGradient>
          <linearGradient id="festifyBalloon" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#d9eeff" />
            <stop offset="100%" stopColor="#8ac7ff" />
          </linearGradient>
        </defs>

        <circle cx="42" cy="42" r="32" fill="url(#festifyCircle)" />
        <circle cx="42" cy="42" r="29" fill="none" stroke="#d5ecff" strokeOpacity="0.45" strokeWidth="1.5" />

        <path d="M27 22 H49 V29 H35 V38 H47 V45 H35 V62 H27 Z" fill="#0f243e" />

        <circle cx="53" cy="25" r="8" fill="url(#festifyBalloon)" />
        <path d="M53 33 L50 37 L56 37 Z" fill="#bfe2ff" />
        <path d="M53 37 L53 55" stroke="#0f243e" strokeWidth="2.6" strokeLinecap="round" />
        <path d="M53 44 L46 36" stroke="#0f243e" strokeWidth="2.6" strokeLinecap="round" />
        <path d="M53 44 L60 36" stroke="#0f243e" strokeWidth="2.6" strokeLinecap="round" />

        {isLarge && (
          <text x="82" y="45" fill="#b9dcff" fontFamily="Montserrat, sans-serif" fontSize="29" fontWeight="700">Festify</text>
        )}
      </svg>
      {subtitle && (
        <div className="festify-logo-text">
          <p>{subtitle}</p>
        </div>
      )}
    </Link>
  );
}
